// extracted by mini-css-extract-plugin
export default {"error_container":"callbotBackendError_error_container__+sk6q","line_separator":"callbotBackendError_line_separator__rgiJe"};